var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"currentColor","viewBox":"0 0 20 20","aria-hidden":"true"}},[_c('path',{attrs:{"d":"M5.555 17.776l8-16 .894.448-8 16-.894-.448z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }